import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales';
import type { AppPropsState } from '@atlassian/jira-servicedesk-common/src/state/app-props/types';
import type { PersistedState } from '../../reducers/persisted/types';
import type { State } from '../../reducers/types';

export const getPersisted = (state: State): PersistedState => state.persisted;
export const getAppProps = (state: State): Partial<AppPropsState> => state.appProps;
export const getLocale = (state: State): Locale => state.appProps.locale;
